<template>
  <div>
    <div id="production-process" class="container remove-padding-margin">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row w-limit">
                <div class="col-md-2 col-sm-2 col-2 remove-padding">
                    <img src="../../assets/gambar/back-blue.svg" alt="" @click="back">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Proses Produksi</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2"></div>
            </div>
        </div>
        <main class="w-limit">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="add-padding-default animasi-card  bg-transparent d-flex mar-top-16 mar-bottom-16">
                        <div class="font-16 status-login color-206CF" id="langkah2"><span class="font-weight-bold color-206CF">Langkah 2/2</span></div>
                        <div class="font-16 status-login color-206CF" id="langkah3"><span class="font-weight-bold color-206CF">Langkah 2/3</span></div>
                        <div class="font-16 status-login color-206CF" id="langkah4"><span class="font-weight-bold color-206CF">Langkah 2/4</span></div>
                    </div>
                    <div class="text-outlets add-padding-default mar-bottom-16">
                        <div class="font-16">Dimanakah proses produksi (cth: mencuci, setrika, pengemasan) dilakukan?</div>
                    </div>
                    <div class="accordion border-top-EDED" id="accordionExample">
                        <!--<div class="baris" @click="accourdionclose">-->
                        <div class="baris" @click="showmodal('ya')">
                            <div class="input-group" style="padding: 20px">
                                <div class="custom-control custom-radio remove-padding-lr">
                                    <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                                           data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                           aria-controls="collapseOne" value="ya" v-model="dataProductionProses.inputradio">
                                    <label class="custom-control-label" for="customRadio1"><b>Di outlet ini</b></label>
                                    <div class="font-14 animated fadeInDown m-t-4 yes-ws" style="padding: 0px 25px; color: #6F7287;" id="yes-new-ws">
                                        <b>Buat workshop baru</b> untuk outlet ini<br>
	                                    <span class="f-c-blue f-semi">Ubah pilihan</span>
                                    </div>
                                    <div class="font-14 animated fadeInDown m-t-4 yes-ws" style="padding: 0px 25px; color: #6F7287;" id="yes-exsisting-ws">
                                        Gabungkan outlet ini dengan workshop <b>{{ (selectedWorkshop.nama) ? selectedWorkshop.nama : '' }}</b><br>
                                        <span class="f-c-blue f-semi">Ubah pilihan</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="baris" @click="showmodal('tidak')">
                            <div class="input-group" style="padding: 20px">
                                <div class="custom-control custom-radio remove-padding-lr">
                                    <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
                                           data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
                                           aria-controls="collapseTwo" value="tidak" v-model="dataProductionProses.inputradio">
                                    <label class="custom-control-label" for="customRadio2"><b>Di workshop terpisah</b></label>
                                    <div class="font-14 animated fadeInDown m-t-4 no-ws" style="padding: 0px 25px; color: #6F7287;" id="no-new-ws">
	                                    <b>Buat workshop baru</b> sebagai tempat pengerjaan proses produksi <br>
	                                    <span class="f-c-blue f-semi">Ubah pilihan</span>
                                    </div>
                                    <div class="font-14 animated fadeInDown m-t-4 no-ws" style="padding: 0px 25px; color: #6F7287;" id="no-exsisting-ws">
	                                    Proses produksi dikerjakan <b>di workshop lain</b> yang sudah pernah dibuat <br>
	                                    <span class="f-c-blue f-semi">Ubah pilihan</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-lanjut add-padding-default">
                    <button class="btn btn-login btn-long" id="BtnProses" @click="choice">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      v-if="this.dataProductionProses.isClicked === true"></span>
                        <span id="textBtnProses">Berikutnya</span>
                    </button>
                </div>
            </div>
        </main>

	    <div class="modal fade" id="modal-inside-outlet" role="dialog">
		    <div class="modal-dialog modal-lg  bani-modal">
			    <div class="modal-content w-limit">
				    <div class="modal-header">
					    <div class="nav-btn kiri"></div>
					    <h5 class="navbar-title text-center">Di outlet ini</h5>
					    <div class="nav-btn kanan tutup">
						    <img src="../../assets/img/x2.svg" @click="promtCloseModal" alt="">
					    </div>
				    </div>
				    <div class="modal-body set-pad pt-0">
					    <div class="new-workshop row remove-padding border-bottom" style="padding: 22px;">
						    <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">
							    <img src="../../assets/icons/circle_add.svg" alt="">
						    </div>
						    <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin" style="padding-left: 22px">
							    <div class="font-14 color-33333 font-weight-bold set-new-workshop" id="new" @click="newWorkshop(true)">Buat workshop baru</div>

						    </div>
					    </div>
					    <div class="same-workshop row remove-padding border-bottom" style="padding: 22px;">
						    <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">
							    <img v-if="lengthWorkshop === 0" src="../../assets/icons/circle_go_grey.svg" alt="">
							    <img v-else src="../../assets/icons/circle_go.svg" alt="">
						    </div>
						    <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin" style="padding-left: 22px">
							    <div v-if="lengthWorkshop === 0" class="font-14 color-33333 font-weight-bold set-new-workshop f-c-midgrey">Gunakan workshop yang sudah ada</div>
							    <div v-else class="font-14 color-33333 font-weight-bold set-new-workshop" id="shameWK" @click="chooseExistingWorkshop(true)"
							         v-html="(selectedWorkshop.nama) ? 'Ubah workshop <span class=\'f-c-blue\'>' + selectedWorkshop.nama + '</span>' : 'Gunakan workshop yang sudah ada'">
							    </div>
						    </div>
					    </div>
				    </div>
			    </div>
		    </div>
	    </div>

	    <div class="modal fade" id="modal-outside-outlet" role="dialog">
		    <div class="modal-dialog modal-lg  bani-modal">
			    <div class="modal-content w-limit">
				    <div class="modal-header">
					    <div class="nav-btn kiri"></div>
					    <h5 class="navbar-title text-center">Di workshop terpisah</h5>
					    <div class="nav-btn kanan tutup">
						    <img src="../../assets/img/x2.svg" @click="promtCloseModal" alt="">
					    </div>
				    </div>
				    <div class="modal-body set-pad pt-0">
					    <div class="new-workshop row remove-padding border-bottom" style="padding: 22px;">
						    <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">
							    <img src="../../assets/icons/circle_add.svg" alt="">
						    </div>
						    <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin" style="padding-left: 22px">
							    <div class="font-14 color-33333 font-weight-bold set-new-workshop" @click="newWorkshop(false)">Buat workshop baru</div>

						    </div>
					    </div>
					    <div class="same-workshop row remove-padding border-bottom" style="padding: 22px;">
						    <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">
<!--							    <img v-if="lengthWorkshop === 0" src="../../assets/icons/circle_go_grey.svg" alt="">-->
							    <img  src="../../assets/icons/circle_go.svg" alt="">
						    </div>
						    <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin" style="padding-left: 22px">
<!--							    <div v-if="lengthWorkshop === 0" class="font-14 color-33333 font-weight-bold set-new-workshop f-c-midgrey">Dikerjakan di workshop yang sudah ada</div>-->
							    <div  class="font-14 color-33333 font-weight-bold set-new-workshop" @click="chooseExistingWorkshop(false)">
								    Dikerjakan di workshop yang sudah ada
							    </div>
						    </div>
					    </div>
				    </div>
			    </div>
		    </div>
	    </div>

<!--        <div class="modal fade" id="modalproduksi" role="dialog">-->
<!--            <div class="modal-dialog modal-lg  bani-modal">-->
<!--                <div class="modal-content w-limit">-->
<!--                    <div class="modal-header">-->
<!--                        <div class="nav-btn kiri"></div>-->
<!--                        <h5 class="navbar-title text-center">Detail Produksi</h5>-->
<!--                        <div class="nav-btn kanan tutup">-->
<!--                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="modal-body set-pad">-->
<!--                        <div class="row remove-padding border-bottom">-->
<!--                            <div class="col-sm-12 col-md-12 col-lg-12 col-12 remove-margin pad-left-right-23" style="padding-top: 6px;padding-bottom: 16px">-->
<!--                                <div>Bagaimana Anda mengatur proses produksi untuk outlet ini?</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="new-workshop row remove-padding border-bottom" style="padding: 22px;">-->
<!--                            <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">-->
<!--                                <img src="../../assets/icons/circle_add.svg" alt="">-->
<!--                            </div>-->
<!--                            <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin"style="padding-left: 22px">-->
<!--                                <div class="font-14 color-33333 font-weight-bold set-new-workshop" id="new" @click="menu('new')">Buat workshop baru</div>-->

<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="same-workshop row remove-padding border-bottom" style="padding: 22px;">-->
<!--                            <div class="col-sm-1 col-md-1 col-lg-1 col-1 remove-padding">-->
<!--                                <img src="../../assets/icons/circle_go.svg" alt="">-->
<!--                            </div>-->
<!--                            <div class="col-sm-11 col-md-11 col-lg-11 col-11 remove-padding-margin" style="padding-left: 22px">-->
<!--	                            <div v-if="lengthWorkshop === 0" class="font-14 color-33333 font-weight-bold set-new-workshop f-c-midgrey">Gunakan workshop yang sudah ada</div>-->
<!--                                <div v-else class="font-14 color-33333 font-weight-bold set-new-workshop" id="shameWK" @click="menu('shameWK')">Gunakan workshop yang sudah ada</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
    <PilihWorkshopSingle id="pilih-ws" style="display:none;" @back="thisPage" @workshopSelected="workshopSelected" ref="pilihworkshopsingleref" />
  </div>
</template>

<script>
    import PilihWorkshopSingle from "@/components/onboarding/PilihWorkshopSingle";

    export default {
        name: "ProductionProcess",
        props:["dataProductionActivity","dataProductionProses"],
        components: { PilihWorkshopSingle },
        mounted(){
            $('#newworkshop').hide();
            $('#shameworkshop').hide();
            $('#langkah3').hide();
            $('#langkah4').hide();
            this.validate()
	        this.checkWorkshop()

	        this.propsDataProductionProcess()
          this.backButtonPressed(this.back)
			this.smartTrackingView("add_outlet_step2");

		},
        data(){
          return{
          	lengthWorkshop: 0,
            prosesProduksi: '',
	        workshopType: "",
            selectedWorkshop: {},
            requestHeaders: {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            }
          }
        },
        methods:{
            back(){
                this.$emit("showDataOutlet")
                $("#modal-inside-outlet").modal("hide")
                $("#modal-outside-outlet").modal("hide")
            },
            showmodal(radio){
                this.prosesProduksi = radio
	            $('input[name="customRadio"][value="' + radio +'"]').prop("checked", "true")
	            if (radio === 'ya') {
		            $('#modal-inside-outlet').modal({backdrop: 'static', keyboard: false});
					this.smartTrackingClick("add_outlet_step2_tempat_produksi_gabung");
	            } else if (radio === 'tidak') {
		            $('#modal-outside-outlet').modal({backdrop: 'static', keyboard: false});
					this.smartTrackingClick("add_outlet_step2_tempat_produksi_terpisah");
	            }
                this.checked()
	            $(".yes-ws").hide()
	            $(".no-ws").hide()

			},
            accordionshownew(){
              $('#newworkshop').show()
              $('#shameworkshop').hide()
            },
            accordionshowwk(){
                $('#shameworkshop').show()
                $('#newworkshop').hide()
            },
            accourdionclose(){
                $('#shameworkshop').hide()
                $('#newworkshop').hide()
                $('#langkah3').show();
                $('#langkah2').hide();
                $('#langkah4').hide();
                this.checked()
            },
            pilih1inside() {
                $('#langkah3').show();
                $('#langkah2').hide();
                $('#langkah4').hide();
            },
            pilih1outside(){
                $('#langkah3').hide();
                $('#langkah2').hide();
                $('#langkah4').show();
            },

            pilih2(){
                $('#langkah3').hide();
                $('#langkah2').show();
                $('#langkah4').hide();
            },

            choice(){

				// $('#textBtnProses').hide();
                // $('#BtnProses').prop('disabled', true);
                // var button_proses = $('#btnNext').prop('disabled',true)
                var pilih_jenisOutlet = $('input[name="customRadio"]:checked').val()
                this.$emit('cekinternet', { "pilih_jenisOutlet": pilih_jenisOutlet, "workshop": this.selectedWorkshop })
            },
	        newWorkshop(inside) {
            	this.menu('new')
		        if (inside) {
			        $("#modal-inside-outlet").modal("hide");
		        } else {
			        $("#modal-outside-outlet").modal("hide");
		        }
	        },
	        chooseExistingWorkshop(inside) {
            	if (inside) {
		            $("#modal-inside-outlet").modal("hide");
		            setTimeout(() => {
			            $("#production-process").hide()
			            $("#pilih-ws").show();
		            },200)
		            this.menu('shameWK')
                this.backButtonPressed(this.$refs.pilihworkshopsingleref.back)
	            } else {
		            $("#modal-outside-outlet").modal("hide");
		            this.menu('shameWK')
	            }
	        },

            menu(tipe, showWorkshop = true){
                this.workshopType = tipe
                if (this.prosesProduksi === 'ya') {
	                $(".yes-ws").hide()
                    if(tipe==='new'){
                    	$("#yes-new-ws").show();
                    	$("#yes-exsisting-ws").hide();

	                    this.checked()
	                    this.pilih1inside();
                    } else {
                        if (showWorkshop) {
                            setTimeout(() => {
                                $("#production-process").hide()
                                $("#pilih-ws").show();
                            },200)
                        }

	                    $("#yes-new-ws").hide();
	                    $("#yes-exsisting-ws").show();

	                    this.checked()
	                    this.pilih2();
                    }
                } else if (this.prosesProduksi === 'tidak') {
	                $(".no-ws").hide()
                    if(tipe==='new'){
	                    $("#no-new-ws").show();
	                    $("#no-exsisting-ws").hide();

	                    this.checked()
	                    this.pilih1outside();
                    }else{
	                    $("#no-new-ws").hide();
	                    $("#no-exsisting-ws").show();

	                    this.checked()
                        this.pilih2();
                    }
                }

	            setTimeout(()=>{
		            this.$emit('selectfromModal',tipe)
	            },1000)
            },

            validate(){
              return
              if(this.dataProductionProses.inputradio!=='') {
                  $('#BtnProses').prop('disabled',false)
                  if($('input[name="customRadio"]:checked').val()==='tidak'){
                      this.pilih2();
                      this.accordionshowwk()
                  }
              } else{
                  $('#BtnProses').prop('disabled',true)
              }
            },

            checked(){
            	var checkedValue = $('input[name="customRadio"]:checked').val()
                if(checkedValue !== undefined){
                    $('#BtnProses').prop('disabled',false)
                }else {
                    $('#BtnProses').prop('disabled',true)
                }
            },
	        async checkWorkshop() {
            	try {
		            var idowner = localStorage.getItem('idowner');
		            const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_single', this.requestHeaders)
		            this.lengthWorkshop = res.data.data.length
	            } catch (e) {
            	    this.$catch_error_response(e)
	            }
	        },
            thisPage() {
                $("#production-process").show()
                if (!this.selectedWorkshop.idworkshop) {
                    $("#modal-inside-outlet").modal("show")
                }
                $("#pilih-ws").hide();
                this.backButtonPressed(this.back)
            },
            workshopSelected(workshop) {
                this.selectedWorkshop = workshop
	            $("#yes-exsisting-ws").show();
                this.thisPage();
            },
	        propsDataProductionProcess() {
            	if (this.dataProductionProses.inputradio !==  "") {
		            // $(".yes-ws").hide()
		            // $(".no-ws").hide()
            		$('input[name="customRadio"][value="' + this.dataProductionProses.inputradio +'"]').prop("checked", "true")

                    this.prosesProduksi = this.dataProductionProses.inputradio
                    this.workshopType = this.dataProductionProses.jenisworkshop

                    if (this.dataProductionProses.inputradio === "ya") {
			            if (this.dataProductionProses.jenisworkshop === "new") {
				            $("#yes-new-ws").show();
				            $("#yes-exsisting-ws").hide();
				            this.pilih1inside()
			            } else {
				            $("#yes-new-ws").hide();
				            $("#yes-exsisting-ws").show();
				            this.pilih2()
			            }
		            } else {
			            if (this.dataProductionProses.jenisworkshop === "new") {
				            $("#no-new-ws").show();
				            $("#no-exsisting-ws").hide();
				            this.pilih1outside()
			            } else {
				            $("#no-new-ws").hide();
				            $("#no-exsisting-ws").show();
                            this.pilih2()
			            }
		            }
	            }
	        },
            promtCloseModal() {
                if (this.workshopType !== "") {
                    if (this.prosesProduksi === "ya" && this.workshopType === "shameWK" && this.selectedWorkshop.idworkshop === undefined) {
                        this.$toast.error("Anda belum memilih detail produksi untuk outlet ini")
                        return
                    }

                    this.menu(this.workshopType, false);
                    (this.prosesProduksi === 'ya') ? $("#modal-inside-outlet").modal("hide") : $("#modal-outside-outlet").modal("hide")
                } else {
                    this.$toast.error("Anda belum memilih detail produksi untuk outlet ini")
                }
            }
        }
    }
</script>

<style scoped>
    .baris{
        border-bottom: 1px solid #EDEDED;
    }
    .set-new-workshop{
        line-height: 140%;
        letter-spacing: -0.02em;
    }

    .border-bottom{
        border-bottom: 1px solid #EDEDED;
    }
    .set-pad{
        padding: 15px 15px 0px 15px;
    }

    .yes-ws {
        display: none;
    }

    .no-ws {
	    display: none;
    }
</style>